export const currentDate = new Date();
export const currentYear = currentDate.getFullYear();
export const printDateFormat = { year: 'numeric', month: '2-digit', day: '2-digit' };
